import { useQuery } from "@apollo/client";
import { ErrorMessage } from "@/shared/components";
import LinearProgress from "@mui/material/LinearProgress";
import { CrudDialogHeader } from "./CrudDialogHeader";

export interface CrudShowProps<Data = any> {
  id: string;
  showQuery: any;
  showPollInterval?: number;
  /** true пропускает тик опроса (например, в скрытой вкладке). */
  showSkipPollAttempt?: () => boolean;
  showComponent: React.ComponentType<Data>;
  showQueryVariables?: Record<string, any>;
  onClose?: () => void;
  title?: string;
  subTitle?: string;
  getTitle?: (data: Data) => string | null;
}

export function CrudShow<Data = any>({
  id,
  showQuery,
  showPollInterval,
  showSkipPollAttempt,
  showComponent: Component,
  showQueryVariables,
  onClose,
  title,
  subTitle,
  getTitle = () => null,
}: CrudShowProps<Data>) {
  const { data, loading, error } = useQuery(showQuery, {
    pollInterval: showPollInterval,
    skipPollAttempt: showSkipPollAttempt,
    fetchPolicy: "cache-and-network",
    variables: {
      id,
      ...showQueryVariables,
    },
  });

  if (error) return <ErrorMessage error={error} />;
  if (loading && !data) return <LinearProgress />;

  return (
    <>
      <CrudDialogHeader
        position="absolute"
        onClose={onClose}
        secondary={title}
        primary={subTitle}
        title={getTitle(data)}
      />
      <Component {...data} id={id} />
    </>
  );
}
